
export const ManoshalaProInfo = (props:any) => {
    const {term_length,price} = props;
  return (
    <div className="col-sm-6 px-4">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Term length:</th>
            <td>{term_length}</td>
          </tr>
          <tr>
            <th scope="row">Price:</th>
            <td>{price}</td>
          </tr>
          </tbody>
      </table>
    </div>
  )
}
